module.exports = __webpack_public_path__ + "static/media/PDFsigneblockHeader2.e1c8716c.png";